import { Component, ContentChildren, ElementRef, Input, QueryList, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { MenuItemComponent } from '@sb/library/button';
import { FormContainerKind } from '@sb/library/base';
import { FormFieldBaseComponent } from '../../form-field-base.component';

@Component({
    selector: 'lib-split-checkbox',
    templateUrl: './split-checkbox.component.html',
    styleUrls: ['./split-checkbox.component.scss']
})
export class SplitCheckboxComponent extends FormFieldBaseComponent<boolean, FormControl<boolean>> {


    @ContentChildren(MenuItemComponent) menuItemComponents!: QueryList<MenuItemComponent>;

    @Input() hasBackdrop: boolean = true;
    @Input() isIndeterminate: boolean = false;
    @Input() disabled: boolean = false;


    constructor() {
        super()
        this.viewControl = new FormControl(false, {nonNullable: true});
    }


    OpenMenuFromButton(menu: MatMenuTrigger): void {
        menu.toggleMenu();
    }

    Change(checked: boolean): void {
        this.change.emit(checked);
    }

    MenuItemClicked(item: MenuItemComponent, event: MouseEvent) {
        if (!item.disabled) {
            item.clicked.emit();
        }

        if (item.stopPropagation) {
            event.stopPropagation();
        }
    }

}
